import * as _ from "lodash";

import { Light } from "@/models";

export const types = {
    ADD_LIGHTS: "map/mode/add-lights",
    SET_INIT_HISTORY: "map/mode/set-init-history",
    UNDO: "map/mode/undo",
    REDO: "map/mode/redo",
    SET_LIGHTS: "map/mode/set-lights",
    UPDATE_LIGHTS: "map/mode/update-lights",
    UPDATE_LIGHTS_SILENT: "map/mode/update-lights-silent",
    ALIGN_LIGHTS: "map/mode/align-lights",
    ROTATE_LIGHTS: "map/mode/rotate-lights",
    DELETE_LIGHTS: "map/mode/delete-lights",
    SELECT_LIGHTS: "map/mode/select-lights",
    ADD_TEMPORARY_LIGHT: "map/mode/add-temporary-lights",
    ADD_TEMPORARY_MARKER: "map/mode/add-temporary-marker",
    SET_MARKERS: "map/mode/set-markers",
    UPDATE_MARKERS: "map/mode/update-markers",
};

const reduceLights = (lights) =>
    _.reduce(
        lights,
        (result, light) => {
            result[light.uniqueId] = light;
            return result;
        },
        {},
    );

export default {
    addLights: (lights) => ({
        type: types.ADD_LIGHTS,
        payload: {
            lights,
        },
    }),
    rotateLights: (direction) => ({
        type: types.ROTATE_LIGHTS,
        payload: {
            direction,
        },
    }),
    deleteLights: (deletedLights = []) => ({
        type: types.DELETE_LIGHTS,
        payload: deletedLights,
    }),
    alignLights: (alignTypeName) => ({
        type: types.ALIGN_LIGHTS,
        payload: {
            alignTypeName,
        },
    }),
    setInitHistory: () => ({
        type: types.SET_INIT_HISTORY,
    }),
    redo: () => ({ type: types.REDO }),
    undo: () => ({ type: types.UNDO }),
    setLights: (lights, reset = true) => ({
        type: types.SET_LIGHTS,
        payload: {
            lights: Light.reduceLights(lights),
            reset,
        },
    }),
    updateLights: (lights) => ({
        type: types.UPDATE_LIGHTS,
        payload: reduceLights(lights),
    }),
    updateLightsSilent: (lights) => ({
        type: types.UPDATE_LIGHTS_SILENT,
        payload: reduceLights(lights),
    }),
    selectLights: (lights, selectionType = "single") => {
        const lightsIds = _.map(
            lights instanceof Array ? lights : [lights],
            (light) => light.uniqueId,
        );
        return {
            type: types.SELECT_LIGHTS,
            payload: {
                lightsIds,
                selectionType,
            },
        };
    },
    addTemporaryLights: (lights) => {
        return {
            type: types.ADD_TEMPORARY_LIGHT,
            payload: {
                lights: reduceLights(lights),
                lightsIds: _.map(
                    lights instanceof Array ? lights : [lights],
                    (light) => light.uniqueId,
                ),
            },
        };
    },
    addTemporaryMarker: (marker) => ({
        type: types.ADD_TEMPORARY_MARKER,
        payload: { markers: { [marker.uniqueId]: marker } },
    }),
    setMarkers: (markers) => ({
        type: types.SET_MARKERS,
        payload: markers,
    }),
    updateMarkers: (markers) => ({
        type: types.UPDATE_MARKERS,
        payload: markers,
    }),
};
